import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import SelectTemplateStep from 'src/UI/drawer-flow/SelectTemplateStep';
import { Client } from 'src/users';
import { useGenerateMeetingNote } from '../hooks/useGenerateMeetingNote';

type MeetingNoteData = {
  client?: Client;
  selectedTemplateId?: string;
  selectedRecordingId?: string;
};

export default function MeetingNoteSelectTemplateStep(props: StepProps<MeetingNoteData>) {
  const { generateMeetingNote, isLoading } = useGenerateMeetingNote();

  const handleGenerateMeetingNote = async () => {
    if (!props.data.client) {
      throw new Error('Client not found');
    }
    if (!props.data.selectedRecordingId) {
      throw new Error('Recording not selected');
    }
    if (!props.data.selectedTemplateId) {
      throw new Error('Template not selected');
    }
    try {
      await generateMeetingNote(props.data.client.id, {
        dataUploadFileId: props.data.selectedRecordingId,
        templateId: props.data.selectedTemplateId,
      });
      props.onSuccess();
    } catch (error) {
      notifyAndLogError('Error', 'Failed to generate meeting notes', error);
    }
  };
  return (
    <SelectTemplateStep
      {...props}
      type="MEETING_NOTE"
      description="Please choose a template which Siesta AI will use to base the client specific meeting note on."
      clientNameSuffix="meeting notes"
      continueText={isLoading ? 'Generating...' : 'Generate meeting note'}
      canGoForward={!isLoading}
      canGoBack={!isLoading}
      nextStep={handleGenerateMeetingNote}
      isSubmitting={isLoading}
    />
  );
}
